import { useAuthentication } from '@/hooks/useAuthentication';
import { useHomeStore } from '../useHome';
import DailyStreaks from '@/components/DailyStreaks';

export const Header = () => {
  const { page } = useHomeStore();
  const { authentication } = useAuthentication();
  return (
    <>
      <div className="flex flex-col justify-between gap-sh-15 lg:flex-row">
        <div className="w-full">
          <h1 className=" mb-sh-15 font-larken !text-sh-48-48">Hello, {authentication.user.forename || 'Guest'}</h1>
          <p className="max-w-[500px] text-sh-18-24">{page?.headerSection.message}</p>
        </div>
        <div className="w-full">
          <DailyStreaks />
        </div>
      </div>
    </>
  );
};
